import { useState, useRef, useEffect } from 'react';
import { useLang, FLAGS } from '@/lib/i18n';

const LANGS = [
  { code: 'pl', name: 'Polski' },
  { code: 'en', name: 'English' },
  { code: 'ru', name: 'Русский' },
  { code: 'ua', name: 'Українська' },
];

export default function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  return (
    <div ref={ref} className="relative" data-testid="language-switcher">
      <button onClick={() => setOpen(!open)} data-testid="lang-toggle"
        className="flex items-center gap-1.5 px-2 py-1.5 rounded-lg bg-white/5 hover:bg-white/10 transition-colors border border-white/10">
        {FLAGS[lang]}
        <span className="text-xs text-white/60 uppercase hidden sm:inline">{lang}</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-black/95 backdrop-blur-xl border border-white/10 rounded-xl overflow-hidden shadow-2xl z-50 min-w-[140px]">
          {LANGS.map(l => (
            <button key={l.code} data-testid={`lang-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-xs transition-colors ${
                lang === l.code ? 'bg-[var(--color-primary)]/10 text-[var(--color-primary)]' : 'text-white/60 hover:bg-white/5 hover:text-white'
              }`}>
              {FLAGS[l.code]}
              <span>{l.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
